import Axios from 'axios';
import React, { Component } from 'react';
import { withRouter } from 'utils/common';
import i18n from 'utils/translate';
import ContentLoader from '../../components-locations/ContentLoader';
import NoResults from '../../components-locations/NoResults';
import Office from '../../components-locations/Office';
import SidebarFilter from '../../components-locations/SidebarFilter';
import UserLocationFiltering from '../../components-locations/UserLocationFiltering';
import endpoints from '../../utils/endpoints';
import {
  filterObjects,
  FILTER_LANGUAGE,
  FILTER_REGION_NAME,
  FILTER_ZIP_AND_COMMUNITY,
  getCommuntyFromCombinedValue,
  getZipcodeFromCombinedValue,
  loadLanguages,
  loadRegions,
  loadRegionsDistinct,
  readFiltersFromURL,
  writeFiltersToURL
} from '../../utils/filters';
import { filterObjectsByLocation, isLocationAPIAvailable } from '../../utils/location';
import { makeBootstrapRows } from '../../utils/rendering';

const availableFilters = [FILTER_ZIP_AND_COMMUNITY, FILTER_REGION_NAME, FILTER_LANGUAGE];

const defaultState = {
  dataLoaded: false,
  locationError: false,
  zipcodeAndCommunityOptions: [],
  communityOptions: [],
  regionOptions: [],
  offices: [],
  allOffices: [],
  allOfficesBackup: [],
  filters: {},
  previousFilters: {},
  regions: [],
  locationBasedDataRendered: false
};

class AdvisorContainer extends Component {
  constructor(props) {
    super(props);
    this.state = defaultState;
  }

  componentDidMount() {
    this.loadFilters();
    this.reloadOffices();
    this.setState({ filters: readFiltersFromURL(availableFilters) });
  }

  render() {
    let officesContent;
    if (this.state.dataLoaded) {
      const offices = this.state.offices;
      if (offices.length) {
        let officesElements = this.state.offices.map((office, i) => {
          return (
            <div className="col-xs-12" key={i}>
              <Office
                office={office}
                key={i}
                onCommunityClick={this.handleCommunityClick.bind(this)}
                onRegionClick={this.handleRegionClick.bind(this)}
              ></Office>
            </div>
          );
        });
        officesContent = makeBootstrapRows(officesElements, 1);
      } else {
        officesContent = (
          <NoResults
            showUserLocationFiltering={isLocationAPIAvailable() && !this.state.locationError}
            onLocationClick={this.handleUserLocationClick.bind(this)}
          ></NoResults>
        );
      }
    } else {
      officesContent = (
        <div>
          <ContentLoader></ContentLoader>
        </div>
      );
    }
    return (
      <div className="row">
        <aside className="col-md-3">
          <div className="filter-container">
            <SidebarFilter
              renderedFields={availableFilters}
              filters={this.state.filters}
              onFiltersChanged={this.filtersChanged.bind(this)}
              regions={this.state.regions}
              zipcodeAndCommunityOptions={this.state.zipcodeAndCommunityOptions}
              regionOptions={this.state.regionOptions}
              languageOptions={this.state.languageOptions}
            ></SidebarFilter>
            <div>
              {isLocationAPIAvailable() && !this.state.locationError ? (
                <UserLocationFiltering
                  linkClassName="sidebar-location-search"
                  onLocationClick={this.handleUserLocationClick.bind(this)}
                ></UserLocationFiltering>
              ) : null}
              {this.state.locationError ? (
                <div className="sidebar-location-error">{i18n('could-not-resolve-location')}</div>
              ) : null}
            </div>
          </div>
        </aside>
        <div className="col-md-9">{officesContent}</div>
      </div>
    );
  }

  filtersChanged(filters) {
    const previousFilters = { ...this.state.filters };
    this.setState({ filters: filters, previousFilters: previousFilters }, () => {
      window.scrollTo({ top: 0 });
      writeFiltersToURL(this.state.filters);
      this.filterOffices();
    });

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'interne-suche',
        'suche-action': 'Kundencenter',
        location: filters[FILTER_REGION_NAME] ? filters[FILTER_REGION_NAME] : '',
        adressregion: filters[FILTER_ZIP_AND_COMMUNITY] ? filters[FILTER_ZIP_AND_COMMUNITY] : '',
        languages: filters[FILTER_LANGUAGE] ? filters[FILTER_LANGUAGE] : ''
      });
    }
  }

  reloadOffices() {
    Axios.get(endpoints.locations.OFFICES).then(res => {
      const offices = res.data.offices;
      this.setState({ allOffices: offices, allOfficesBackup: [...offices], dataLoaded: true }, () => {
        this.filterOffices();
      });
    });
  }

  reloadOfficesFiltered(zipcode, community) {
    this.setState({ dataLoaded: false });
    Axios.get(`${endpoints.locations.OFFICES}&zip=${zipcode}&community=${community}&radius=1&no_cache=1`).then(res => {
      const offices = res.data.offices;
      const previousFilters = { ...this.state.filters };
      this.setState(
        { locationBasedDataRendered: true, allOffices: offices, dataLoaded: true, previousFilters: previousFilters },
        () => {
          this.filterOffices();
        }
      );
    });
  }

  loadFilters() {
    loadRegions((regions, zipcodeOptions, communityOptions, zipcodeAndCommunityOptions) => {
      this.setState({
        regions: regions,
        zipcodeAndCommunityOptions: zipcodeAndCommunityOptions
      });
    });
    loadRegionsDistinct(regionsDistint => this.setState({ regionOptions: regionsDistint }));
    loadLanguages(languageOptions => this.setState({ languageOptions: languageOptions }));
  }

  filterOffices() {
    const { filters, allOffices, allOfficesBackup, previousFilters } = this.state;
    const doBackendFiltering =
      filters[FILTER_ZIP_AND_COMMUNITY] &&
      filters[FILTER_ZIP_AND_COMMUNITY] !== previousFilters[FILTER_ZIP_AND_COMMUNITY];
    if (doBackendFiltering) {
      this.reloadOfficesFiltered(
        getZipcodeFromCombinedValue(filters[FILTER_ZIP_AND_COMMUNITY]),
        getCommuntyFromCombinedValue(filters[FILTER_ZIP_AND_COMMUNITY])
      );
    } else {
      let filterSource = allOfficesBackup;
      let backendFiltered = false;
      if (filters[FILTER_ZIP_AND_COMMUNITY]) {
        filterSource = allOffices;
        backendFiltered = true;
      }
      this.setState({
        offices: filterObjects(filters, filterSource),
        locationBasedDataRendered: backendFiltered,
        dataLoaded: true
      });
    }
  }

  handleCommunityClick(regionName, regionCommunity, zipcode) {
    const filters = {};
    filters[FILTER_ZIP_AND_COMMUNITY] = `${zipcode}_${regionCommunity}`;
    this.filtersChanged(filters);
  }

  handleRegionClick(regionName) {
    const filters = {};
    filters[FILTER_REGION_NAME] = regionName;
    this.filtersChanged(filters);
  }

  handleUserLocationClick() {
    this.setState({ dataLoaded: false });
    filterObjectsByLocation(
      [FILTER_ZIP_AND_COMMUNITY],
      this.state.regions,
      this.handleFilteredByAutoZipcode.bind(this),
      this.handleLocationError.bind(this)
    );
  }

  handleFilteredByAutoZipcode(filters) {
    this.setState({ dataLoaded: true });
    this.filtersChanged(filters);
  }

  handleLocationError() {
    this.setState({ locationError: true, dataLoaded: true });
  }
}

export default withRouter(AdvisorContainer);
